export const attachDuplicateCheckbox = (editor, datatable) => {
  const duplicateFamilyField = {
    dataProp: "duplicate_families",
    label: "",
    name: "duplicate_families",
    type: "checkbox",
    ipOpts: [
      {
        label: "Duplicate family relationships",
        value: 1,
      },
    ],
    def: 1,
    unselectedValue: 0,
    separator: ",",
  };
  const duplicateInventoryField = {
    dataProp: "duplicate_inventory_id",
    label: "",
    name: "duplicate_inventory_id",
    type: "checkbox",
    ipOpts: [
      {
        label: "Duplicate inventory ID",
        value: 1,
      },
    ],
    def: 1,
    unselectedValue: 0,
    separator: ",",
  };

  editor.one("closed", () => {
    editor.clear([
      "duplicate_families",
      "duplicate_inventory_id",
      "upc_to_duplicate",
    ]);
  });

  editor
    .add(duplicateFamilyField, null)
    .add(duplicateInventoryField, null)
    .add({
      type: "hidden",
      name: "upc_to_duplicate",
      def: datatable.row({ selected: true }).data().supply.upc,
    });
};
